import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';
import { REACT_BASE_URL } from '../api/Apis';

export function useTempSocket(callbacks) {
  const tempSocketRef = useRef();

  useEffect(() => {
    const tempSocket = io(`${REACT_BASE_URL}/temp`);
    tempSocketRef.current = tempSocket;

    callbacks.map(({ event, cb }) => {
      tempSocket.on(event, cb);
    });

    return () => {
      tempSocket.close();
    };
  }, []);

  return {
    requestConfigIEC104: () => {
      tempSocketRef.current.emit('request-config-iec-104');
    },
    configIEC104: (payload) => {
      tempSocketRef.current.emit('config-iec-104', payload);
    },
  };
}
